
export default [{
	path: '/productsattributes',
	component: () => import('@/components/productsattributes/List')
}]
